import * as React from 'react'
import { cn } from '@/lib/utils'
import type { LucideIcon } from 'lucide-react'

interface SectionHeaderProps {
  title: string
  description?: string
  icon?: LucideIcon
  action?: React.ReactNode
  className?: string
}

export function SectionHeader({ title, description, icon: Icon, action, className }: SectionHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between', className)}>
      <div className="flex items-start gap-3 min-w-0">
        {Icon && (
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-orange-500/20 to-orange-500/5 ring-1 ring-inset ring-orange-500/20">
            <Icon className="h-4 w-4 text-orange-600 dark:text-orange-300" />
          </div>
        )}
        <div className="min-w-0">
          <h2 className="text-lg md:text-xl font-semibold text-neutral-900 dark:text-white tracking-tight truncate">{title}</h2>
          {description && <p className="text-sm text-neutral-500 dark:text-neutral-500 dark:text-white/50 truncate">{description}</p>}
        </div>
      </div>
      {action && <div className="flex shrink-0 items-center gap-2">{action}</div>}
    </div>
  )
}
